module.exports = __webpack_public_path__ + "img/img_brand26.d466e766.jpg";